import { Modal } from 'bootstrap-italia/dist/bootstrap-italia.esm.js';

const galleryState = new WeakMap();

const getGalleryContext = (galleryContainer) => {
  const wrapper = galleryContainer.closest('.it-gallery-wrapper');
  const modalElement = wrapper?.querySelector('.js-gallery-modal');
  const modalImage = modalElement?.querySelector('.js-gallery-modal-image');
  const modalTitle = modalElement?.querySelector('.js-gallery-modal-title');
  const modalDescription = modalElement?.querySelector('.js-gallery-modal-description');
  const prevButton = modalElement?.querySelector('.js-gallery-prev');
  const nextButton = modalElement?.querySelector('.js-gallery-next');
  const openButtons = Array.from(galleryContainer.querySelectorAll('.js-gallery-open'));
  const modal = modalElement ? Modal.getOrCreateInstance(modalElement) : null;

  return {
    galleryContainer,
    wrapper,
    modalElement,
    modalImage,
    modalTitle,
    modalDescription,
    prevButton,
    nextButton,
    openButtons,
    modal
  };
};

const updateModalImage = (context) => {
  const state = galleryState.get(context.galleryContainer) || { currentIndex: 0 };
  const activeButton = context.openButtons[state.currentIndex];
  if (!activeButton || !context.modalImage) {
    return;
  }

  context.modalImage.src = activeButton.dataset.imageSrc || '';
  context.modalImage.alt = activeButton.dataset.imageAlt || '';

  // const imageTitle = (activeButton.dataset.imageTitle || '').trim();
  // if (context.modalTitle) {
  //   context.modalTitle.textContent = imageTitle;
  //   context.modalTitle.classList.toggle('d-none', imageTitle === '');
  // }

  const imageDescription = (activeButton.dataset.imageDescription || '').trim();
  if (context.modalDescription) {
    context.modalDescription.textContent = imageDescription;
    context.modalDescription.classList.toggle('d-none', imageDescription === '');
  }
};

const setupShowMore = (galleryContainer) => {
  const initialVisible = Number(galleryContainer.dataset.initialVisible || 6);
  const showStep = Number(galleryContainer.dataset.showStep || 3);
  const wrapper = galleryContainer.closest('.it-gallery-wrapper');
  const items = Array.from(galleryContainer.querySelectorAll('[data-gallery-item]'));
  const showMoreButton = wrapper?.querySelector('.js-mir-gallery-show-more');
  let visibleCount = Math.min(initialVisible, items.length);

  const updateVisibleItems = () => {
    items.forEach((item, index) => {
      item.classList.toggle('d-none', index >= visibleCount);
    });
    if (showMoreButton) {
      showMoreButton.classList.toggle('d-none', visibleCount >= items.length);
    }
  };

  showMoreButton?.addEventListener('click', () => {
    visibleCount = Math.min(items.length, visibleCount + showStep);
    updateVisibleItems();
  });

  updateVisibleItems();
};

const setupGallery = (galleryContainer) => {
  setupShowMore(galleryContainer);
  galleryState.set(galleryContainer, { currentIndex: 0 });
};

const bootstrapGalleries = () => {
  const galleries = document.querySelectorAll('.js-mir-gallery');
  galleries.forEach((gallery) => setupGallery(gallery));
};

document.addEventListener('click', (event) => {
  const transcriptionToggle = event.target.closest('.js-transcription-toggle');
  if (transcriptionToggle) {
    const targetId = transcriptionToggle.dataset.targetId;
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) {
      return;
    }

    const isHidden = target.classList.contains('d-none');
    target.classList.toggle('d-none', !isHidden);
    transcriptionToggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');

    const icon = transcriptionToggle.querySelector('.js-transcription-icon');
    const iconUse = transcriptionToggle.querySelector('.js-transcription-icon-use');
    if (icon && iconUse) {
      const nextExpanded = isHidden;
      const nextHref = nextExpanded ? iconUse.dataset.collapseIcon : iconUse.dataset.expandIcon;
      if (nextHref) {
        iconUse.setAttribute('href', nextHref);
      }
      icon.classList.toggle('is-open', nextExpanded);
    }
    return;
  }

  const openButton = event.target.closest('.js-gallery-open');
  if (!openButton) {
    return;
  }

  const galleryContainer = openButton.closest('.js-mir-gallery');
  if (!galleryContainer) {
    return;
  }

  const context = getGalleryContext(galleryContainer);
  if (!context.modal || !context.modalImage || context.openButtons.length === 0) {
    return;
  }

  const clickedIndex = Number(openButton.dataset.imageIndex || 0);
  galleryState.set(galleryContainer, { currentIndex: clickedIndex });
  updateModalImage(context);
  context.modal.show();
});

document.addEventListener('click', (event) => {
  const navButton = event.target.closest('.js-gallery-prev, .js-gallery-next');
  if (!navButton) {
    return;
  }

  const modalElement = navButton.closest('.js-gallery-modal');
  const wrapper = modalElement?.closest('.it-gallery-wrapper');
  const galleryContainer = wrapper?.querySelector('.js-mir-gallery');
  if (!galleryContainer) {
    return;
  }

  const context = getGalleryContext(galleryContainer);
  if (context.openButtons.length === 0) {
    return;
  }

  const state = galleryState.get(galleryContainer) || { currentIndex: 0 };
  const direction = navButton.classList.contains('js-gallery-prev') ? -1 : 1;
  let nextIndex = state.currentIndex + direction;

  if (nextIndex < 0) {
    nextIndex = context.openButtons.length - 1;
  }
  if (nextIndex >= context.openButtons.length) {
    nextIndex = 0;
  }

  galleryState.set(galleryContainer, { currentIndex: nextIndex });
  updateModalImage(context);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapGalleries);
} else {
  bootstrapGalleries();
}
